import { OrdersService } from '../../services/order/orders.service';
import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';

@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.component.scss'],
  providers: [OrdersService]
})
export class TicketComponent implements OnInit {
  @Input()
  idOrder: number;
  @Input()
  printButton = true;
  order: any = {};
  elements: any[] = [];
  menus: any[] = [];
  paymentModes: any[] = [];
  ticketContent: any;
  num: null;
  loading = true;
  constructor(private ordersService: OrdersService) {
  }

  ngOnInit() {
    // if (this.idOrder != 0) {
    //   this.ordersService.getOrder(this.idOrder).subscribe(
    //     order => {
    //       this.order = order;
    //     }
    //   )
    //   this.ordersService.getOrderElements(this.idOrder).subscribe(
    //     (elements: any[]) => {
    //       this.elements = elements;
    //     }
    //   )
    //   this.ordersService.getOrderMenus(this.idOrder).subscribe(
    //     (menus: any[]) => {
    //       this.menus = menus;
    //     }
    //   )
    //   this.ordersService.getOrderPaymentModes(this.idOrder).subscribe(
    //     (paymentModes: any[]) => {
    //       this.paymentModes = paymentModes;
    //     }
    //   )
    // }
    setTimeout(
      () => {
        if (this.idOrder && this.idOrder != 0) {
          this.ordersService.getOrderTicket(this.idOrder).subscribe(
            (resp: any) => {
              this.ticketContent = resp.template
              this.loading = false;
              this.num = resp.num;
            }
          )
        }
      }, 200
    )
  }
  printTicket() {
    var elem = document.getElementById("printThis")
    var domClone = elem.cloneNode(true);

    var $printSection = document.getElementById("printSection");

    if (!$printSection) {
      $printSection = document.createElement("div");
      $printSection.id = "printSection";
      document.body.appendChild($printSection);
    }
    $printSection.innerHTML = "";
    $printSection.appendChild(domClone);
    window.print();
  }

}
